/*
 * サブシステム名：運用
 * 機能名：利用規約
 */

<template>
  <v-form class="pa-10">
    <v-container fill-height>
      <v-card class="mx-auto" min-width="45vw" min-height="415px" max-width="60vw" style="border-radius: 10px;">
        <v-row no-gutters justify="center">
          <v-img src="@/assets/ddlogo.png" max-width="22vw" max-height="10vh" contain class="mt-3"></v-img>
        </v-row>
        <v-row no-gutters>
          <v-col class="mt-0 px-1">
            <dd-section-title>
              <span class="view-title">{{ riyokiyakuTitle }}</span>
            </dd-section-title>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <span v-html = riyokiyakuHonbun />
          </v-col>
        </v-row>
        <p style="white-space:pre-wrap;"></p>
        <v-row no-gutters justify="center" class="my-5">
          <dd-transparent-button
            v-show="false"
            :disabled="true"
          />
          <dd-custom-button
            :rounded="true"
            :minWidth="160"
            @click="onAcceptClick"
          >
            確認しました
          </dd-custom-button>
        </v-row>
      </v-card>
    </v-container>
  </v-form>
</template>
<script>
import DdSectionTitle from '@/components/DdSectionTitle'
import viewMixins from '@/mixins/viewMixins'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'

export default {
  name: 'RiyoKiyaku',
  mixins: [
    viewMixins
  ],
  components: {
    DdSectionTitle,
    DdCustomButton,
    DdTransparentButton
  },
  data: () => ({
    id: 0,
    riyokiyakuTitle: '',
    riyokiyakuHonbun: ''
    /*,
    disabledButton: true
    */
  }),
  computed: {
    ...mapGetters({
      msyssystemconfig: 'DDMasters/msysSystemConfig'
    })
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
    // window.addEventListener('scroll', this.scrollRiyoKiyaku)
  },
  methods: {
    initialize: function () {
      this.Effects.loadStart()
      this.getRiyoKiyakuForLite()
    },
    getRiyoKiyakuForLite: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/MstRiyokiyaku/GetRiyoKiyakuForLite?id=${this.id}`)
          .then((data) => {
            if (!data.payload) {
              this.Effects.loadComplete()
              var url = location.href
              url = url.substring(0, url.indexOf('#/'))
              window.location.href = url
            } else {
              this.riyokiyakuTitle = data.payload.riyokiyakuTitle
              let riyokiyaku = data.payload.riyokiyakuText
              riyokiyaku = riyokiyaku.replaceAll('\\n', '<br>').replaceAll('\\r', '<br>')
              this.riyokiyakuHonbun = riyokiyaku
              this.Effects.loadComplete()
            }
            resolve()
          })
      })
    },
    onAcceptClick: function () {
      this.Effects.loadStart()
      this.HttpClient
        .get(`/api/v1/MstUsanaviKokyaku/ChangeStatus?id=${this.id}&changeMode=2`)
        .then((data) => {
          var url = location.href
          url = url.substring(0, url.indexOf('#/'))
          window.location.href = url
        }
        )
    }
    /*,
    scrollRiyoKiyaku: function () {
      console.log(window.innerHeight)
      const bodyHeight = document.body.clientHeight // bodyの高さを取得
      const windowHeight = window.innerHeight // windowの高さを取得
      const bottomPoint = bodyHeight - windowHeight
      const currentPos = window.pageYOffset // スクロール量を取得
      if (bottomPoint <= currentPos) { // スクロール量が最下部の位置を過ぎたかどうか
        this.disabledButton = false
      }
    }
    */
  }
}
</script>
<style scoped>
.version-text {
  font-size: small;
  font-family: Verdana;
  font-weight: bold;
}
</style>
